<template>
    <div>
        <!--
        <table border=0 cellspacing=0 width="100%">
            <thead>
                <th width="140">{{ translation.STR_POSITION }}</th>
                <th width="250">{{ translation.STR_BARCODE }}</th>
                <th>{{ translation.STR_TEST }}</th>
                <th>{{ translation.STR_CT_VALUE }}</th>
                <th>{{ translation.STR_HUMAN_CONTROL }}</th>
                <th>{{ translation.STR_TEST_RESULT }}</th>
            </thead>            
            <tr v-for="r in  protoTable.row">
                <td>{{ r.position }}</td>
                <td>{{ r.barcode }}</td>
                <td>{{ protoTable.testtype }}</td>
                <td>
                    <span v-if="r.positive && r.valid">{{ r.ct }}</span>
                    <span v-else>-</span>
                </td>
                <td :class="{ 'invalid': !r.valid}">
                    <span v-if="r.valid">{{ translation.STR_VALID }}</span>
                    <span v-if="!r.valid">{{ translation.STR_INVALID }}</span>                    
                </td>
                <td :class="{ 'positiv' : r.positive }">
                    <span v-if="r.positive">{{ translation.STR_POSITIVE }}</span>
                    <span v-if="!r.positive">{{ translation.STR_NEGATIVE }}</span>
                </td>
            </tr>
            <tr v-if="!protoTable.row">
                <td colspan="10">
                    Befundung wird berechnet.
                </td>
            </tr>
        </table>
        -->
        <table border=0 cellspacing=0 width="100%">
            <thead>
                <th width="140">{{ translation.STR_POSITION }}</th>
                <th width="250">{{ translation.STR_BARCODE }}</th>
                <th>{{ translation.STR_TEST }}</th>
                <th>{{ translation.STR_CT_VALUE }}</th>
                <th>{{ translation.STR_HUMAN_CONTROL }}</th>
                <th>{{ translation.STR_TEST_RESULT }}</th>
            </thead>
            <tr v-for="w in resultTable">
                <td>{{ w["well"]}}</td>
                <td>{{ w["sample"] }}</td>
                <td>{{ test }}</td>
                <td v-if="w['positive'] == true && w['cy5'].positive"><span v-if="w['positive']">{{ w["ct"] <= 38 ? w["ct"] : "" }}</span></td>
                <td v-else>-</td>
                <td :class="{ 'invalid': !w['cy5'].positive }">
                    <span v-if="w['cy5'].positive">{{ translation.STR_VALID }}</span>
                    <span v-if="!w['cy5'].positive">{{ translation.STR_INVALID }}</span>
                </td>
                <td :class="{ 'positiv' : w['positive']}">
                    <span v-if="w['positive']">{{ translation.STR_POSITIVE }}</span>
                    <span v-if="!w['positive']">{{ translation.STR_NEGATIVE }}</span>
                    <span v-if="w.descr">, Info: {{ w.descr }}</span>
                    <span :class="w.class">&nbsp;</span>
                </td>
            </tr>
        </table>


        <div class="btns">
            <input type="button" style="background-color: #964542; border: 1px solid #964542" v-if=" ApoPortalApiEnabled" v-on:click="sendApoPortal()" class="submit" value="Negative an Screening Portal senden" />


            <!--<div :class="[classNameA, {classNameB : condition}]"></div><input type="button" v-if="!testrunning" v-on:click="Export('ws')" class="submit" :value="translation.STR_EXPORT_ZMDX" /><br/>-->
            <!--
            <input type="button" v-if="!testrunning" v-on:click="Export('usb')" class="submit" :value="translation.STR_EXPORT_USB" />
            -->
            <input type="button" v-if="!testrunning" v-on:click="newTest()" class="submit" :value="translation.STR_NEW_TESST" />
        </div>
        </pre>
    </div>
</template>
<script>
import { uuid } from "uuidv4";
import CSVParser from '../../api/libs/csvparser.lib.js';

var protobuf = require("protobufjs");
var root = protobuf.Root.fromJSON(require("../../api/protos/bundle.json"));


export default({
    props: [ 'online', 'translation', 'testrunning', 'hasResults', 'token', 'ApoPortalApiEnabled', 'serial', 'version'],
    mounted() {
        this.getParameters().then(() => {
            this.getResults();
        })

        let { testid = null, test = null, wells = false  } = this.$route.params;
        if(wells) this.tmpwells = wells;
        this.testid = testid;
        this.test = test;
        this.axios.get("http://127.0.0.1:8441/procomcure/?cmd=openlid").catch(() => {
            //this.$emit('triggererror', 'Opening Lid did not work.')
        })
   
    },
    computed: {
        resultTable() {
            var filtered_probes = this.csvresults.filter(e => e.target !== "CY5");
            var control_probes = this.csvresults.filter(e => e.target == "CY5");
            control_probes.forEach((pr) => {
                var i = filtered_probes.find(e => e.well == pr.well);
                if(i) {
                    i.cy5 = pr;
                }
            })
            return filtered_probes;
        }
    },
    methods: {
        sendApoPortal() {
            var filtered_probes = this.csvresults.filter(e => e.target !== "CY5" && e.positive == false);
            if(filtered_probes.length > 0) {
                //this.axios.post("https://fax.reisenbauer.at/procomcure/ApoEndpoint2.php?test="+this.testid+"&token="+this.token, { probes: filtered_probes }).then((r) => {
                this.axios.post("https://poc.m26.at/procomcure/ApoEndpoint2.php?test="+this.testid+"&token="+this.token, { probes: filtered_probes }).then((r) => {
                    alert("Daten erfolgreich gesendet.");
                });                
            }
        },
        newTest() {
            this.$router.push({
                name: 'StartScreen',
            })
        },
        getParameters() {
            return new Promise((resolve, reject) => {
                this.axios.get("/api/parameter?token="+this.token).then((r) => {
                    this.parameters = r.data;
                    resolve(true);
                });
            })
        },
        getResults() {
            this.axios.get("http://127.0.0.1:8441/procomcure/?cmd=getcsv").then((r) => {
            // this.axios.get("/api/mock").then((r) => {
                var csv = atob(r.data.data);
                var arr = csv.split("\n");
                this.gotdata = true;
                var header = arr[0].split(",");
                var headers = [];

                var i = 0;
                header.forEach((e) => {
                    i++;
                    headers.push({
                        id: i,
                        name: e.trim(),
                    })
                })
                var rows = [];



                // search start row quan. amp data
                var ampdata  = [];
                var quanampstart = 0;
                var quanampstop = 0;
                for (let i = 0; i < arr.length; i++) {
                    if(arr[i].trim() == 'Quan. AmpData') quanampstart = i;
                }
                for (let z = quanampstart+2; z < arr.length; z++) {
                    if(arr[z].trim() == 'Quan. Result' && z > (quanampstart+2) && quanampstop == 0) quanampstop = z;
                }
                for (let i = quanampstart+3; i < quanampstop; i++) {
                    var data = arr[i].split(",");
                    ampdata.push({
                        well: data[0],
                        target: data[3],
                        value: parseFloat(data[data.length-1].trim())
                    })
                }



                // search start row (Quan. Result)
                var startrow = 0;
                for (let i = 1; i < arr.length; i++) {
                    if(arr[i].indexOf("Quan. Result") > -1) startrow = i;
                }

                // Well,Sample ID,Property,Target,Dye,Ct,Ct Mean,Ct SD,Concentration,Aver. Con.,Con. SD
                var tmp_res = [];
                for (let i = startrow; i < arr.length; i++) {
                    var row = arr[i].trim()
                    if(row) {
                        var csv = row.trim().split(",");
                        var descr = "";
                        if(csv[1] && csv[1].substring(3) == "NTC") descr = "Negativ Kontrolle";
                        if(csv[1] && csv[1].substring(3) == "TPC") descr = "Positiv Kontrolle";
                        



                        let { cy5 = 100, rox = 1000,cta = 10, ctb = 38 } = this.parameters;


                        switch(csv[3]) {
                            case "CY5":
                                var fluoroszenzwertfilter = cy5;
                            break;
                            case "ROX":
                                var fluoroszenzwertfilter = rox;
                            break;
                        }



                        var ampdata2 = ampdata.find(e => e.well == csv[0] && e.target == csv[3]);
                        if(ampdata2) {

                            var express = false;
                            if(this.tmpwells.length > 0) {
                                var cfgWell = this.tmpwells.find(e => e.fpos == csv[0]);
                                if(cfgWell) {
                                    express = cfgWell.express;
                                }
                            }

                            var obj = {
                                well: csv[0],
                                sample: csv[1],
                                prop: csv[2],
                                target: csv[3],
                                dye: csv[4],
                                ct: csv[5],
                                ct_mean: csv[6],
                                ct_sd: csv[7],
                                ct_concentration: csv[8],
                                aver_con: csv[9],
                                con_sd: csv[10],
                                positive: csv[5] > cta && csv[5] < ctb && ampdata2.value > fluoroszenzwertfilter,
                                descr: descr,
                                class: csv[1] && csv[1].substring(3),
                                cta: csv[5],
                                express: express,
                                tmpwells: this.tmpwells,
                            }
                            if(csv[0].trim().length == 3) {
                                tmp_res.push(obj)
                            }
                        }
                    }
                }
                var tmp = {
                    testid: this.testid,
                    test: this.test,
                    wells: tmp_res,
                    serial: this.serial,
                    version: this.version,
                    params: btoa(JSON.stringify(this.parameters)),
                    csv: arr,
                }

                this.csvresults = tmp_res;
                this.SaveData(tmp);
            }).catch((e) => {
                this.gotdata = false;
                setTimeout(() => {
                    this.getResults();
                }, 1500)
            })
        },
        SaveData(tmp) {
            try {
                var ttt = this;
                var xxx = tmp;
                //this.$emit("devlockf", true);
                this.axios.post('/api/checkin', tmp, { headers: { 'Authorization': 'Barear '+this.token}})
                .then(() => {
                    //this.$emit("devlockf", false);
                })
                .catch(() => {
                    ttt.SaveData(xxx);
                })

                delete tmp["wells"];
                tmp.express = this.tmpwells.filter(e => e.express);
                /*
                this.axios.post('/api/protopost', tmp, { responseType: 'arraybuffer', headers: { 'Authorization': 'Barear '+this.token}})
                .then((response) => {
                    this.$emit("devlockf", false);
                    var rtt = root.lookupType("ResultTable")
                    var result = rtt.decode(Buffer.from(response.data));
                    ttt.protoTable = result;
                })

                // this.SendProto(tmp);
                .catch(() => {
                    this.SaveData(tmp);
                })
                */
            } catch(e) {
                console.log(e);
            }

        },
        SendProto(data) {
            
            var ttt = this;
            var indata = data;
            var csv = new CSVParser;
            var WellHolder = root.lookupType("Wellv2");
            var WELLv2 = root.lookupType("WELLv2");
            var QuanValue = root.lookupType("QuanValue");
            var TestHolder = root.lookupType("Testv2");
            var WellRootObject = [];


            csv.parseCSV(data.csv.join("\n")).then((data) => {
                data.wells.forEach((well) => {
                    var barcoded = data.cache.find(e => e.type == "Quan. Result" && e.well == well)
                    var rawdata1 = data.cache.filter(e => e.type == "Quan. Result" && e.well == well)
                    var cycles = 0;
                    var wells = [];
                    rawdata1.forEach((p) => {
                        let AMPDATA = data.cache.find(e => e.type == "Quan. Raw Data" && e.well == well && e.target == p.target);
                        let AMPDATAA = [];
                        cycles = AMPDATA.data.length;
                        AMPDATA.data.forEach((x) => {
                            AMPDATAA.push(QuanValue.create({
                                value: x,
                            }))
                        })

                        let AMPRAWDATA = data.cache.find(e => e.type == "Quan. AmpData" && e.well == well && e.target == p.target);
                        let AMPRAWDATAA = [];
                        cycles = AMPRAWDATA.data.length;
                        AMPRAWDATA.data.forEach((x) => {
                            AMPRAWDATAA.push(QuanValue.create({
                                value: x.value
                            }))
                        })
                        wells.push(WELLv2.create({
                            dye: p.target,
                            value: p.ct,
                            QuanRAW: AMPDATAA,
                            QuanAMP: AMPRAWDATAA,
                        }))
                    })
                    
                    var express = false;
                    var cfgWell = this.tmpwells.find(e => e.fpos == well);
                    if(cfgWell) {
                        express = cfgWell.express;
                    }

                    let xx = WellHolder.create({
                        barcode: barcoded.sample,
                        position: well,
                        expressOrder: express,
                        Detectors: wells,
                        cycles: cycles,
                    });
                    

                    WellRootObject.push(xx);
                })

                var tmpobj = TestHolder.create({
                    wells: WellRootObject,
                    serial: parseFloat(indata.serial),
                    testtype: indata.test,
                    testid: indata.testid,
                    swVers: indata.version,
                    time: Date.now(),
                })
                var msg = TestHolder.encode(tmpobj).finish();
                var rtt = root.lookupType("ResultTable")
                this.axios.post('/api/v2/proto-checkin', Buffer.from(msg),{ responseType: 'arraybuffer', headers: { 'Authorization': 'Barear '+this.token}}).then(function (response) {
                    var result = rtt.decode(Buffer.from(response.data));
                    ttt.protoTable = result;
                    result.row.forEach((r) => {
                            console.groupCollapsed("Probe: "+r.barcode);
                            console.log("Cycles:", r.cycles);
                            console.log("Position: ", r.position);
                            console.log("Valid:",r.valid);
                            console.log("Express:", r.expressorder)
                            console.log("Positive:", r.positive);
                            console.log("CT: ",r.ct)
                        console.groupEnd();
                    })
                })
            })

        },
        Export(driver) {
            switch(driver) {
                case "usb":
                    this.axios.get("/procomcure/?cmd=exportusb")
                break;
            }
            this.$router.push({
                name: 'export',
                params: {
                    test: this.test,
                    data: this.resultTable,
                    testid: this.testid,
                }
            })

        },
        calcPosition(w) {
            var p = null;
            var t = w.id;

            if(w.row == 1) p="A";
            if(w.row == 2) p="B";
            if(p == "B") {
                t=t-8;
            }

            if(t < 10) t = "0"+t;
            p+=t;
            return p;
        }
    },
    data() {
        return {
            gotdata: false,
            protoTable: [],
            tmpwells: [],
            parameters: {},
            testid: null,
            csv: [],
            wells: [],
            test: null,
            csvresults: [],
        }
    }
})
</script>
<style scoped>
h1 {
    color: var(--primary-color);
}
table {

}
table td {
    padding: 5px;
}

tr:nth-child(odd) {
    background-color: rgba(240,240,240,0.9);
}

.positiv {
    background-color: pink;
    font-weight: bold;
}

.btns {
    display: flex;
}
.submit {
    padding: 15px;
    margin-top: 15px;
    background-color: var(--primary-color);
    color: var(--secondary-color);
    border: 1px solid var(--primary-color);
    cursor: pointer;
    margin-right: 10px;
}

.TPC {
    width: 10px;
    background-color: red !important;
    float: right;
}
.NTC {
    width: 10px;
    background-color: green !important;
    float: right;
}

.invalid {
    background-color: orange;
}
</style>